import { useEffect, useState } from "react";
import { useHistory, useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const Breadcrumb = (props) => {
  const [linkHistory, setLink] = useState([]);
  const history = useHistory();
  let location = useLocation();

  useEffect(() => {
    setLink(location.pathname.split("/"));
  }, [location.pathname]);

  function isLast(index) {
    return index === linkHistory.length - 1;
  }

  function isLastButOne(index) {
    return index === linkHistory.length - 2;
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <>
      <div className="row">
        <nav className="breadcrumb-container pl-2" aria-label="breadcrumb">
          <ol className="breadcrumb">
            {location.pathname !== "/" && location.pathname !== "/" && (
              <>
                {" "}
                <p>
                  {
                    <>
                      <li className={"breadcrumb-item "}>
                        <Link to={"/" + ""}>Home</Link>
                      </li>
                    </>
                  }
                </p>
                {linkHistory.map((x, index) => (
                  <p key={index}>
                    {
                      <>
                        {isLast(index) ? (
                          <li className={"breadcrumb-item active"}>
                            <a>
                              {capitalizeFirstLetter(x.split("_").join(" "))}
                            </a>
                          </li>
                        ) : isLastButOne(index) && history.length > 2 ? (
                          <li
                            onClick={() => history.goBack()}
                            className={"breadcrumb-item "}
                          >
                            <span
                              className="breadCrumbCustom"
                              style={{ cursor: "pointer" }}
                            >
                              {capitalizeFirstLetter(x.split("_").join(" "))}
                            </span>
                            <span className="separator">/</span>
                          </li>
                        ) : history.length <= 2 ? (
                          <li className={"breadcrumb-item "}>
                            <Link to={"/home"}>
                              {capitalizeFirstLetter(x.split("_").join(" "))}
                            </Link>
                            <span className="separator">/</span>
                          </li>
                        ) : (
                          <li className={"breadcrumb-item "}>
                            <Link to={"/" + x}>
                              {capitalizeFirstLetter(x.split("_").join(" "))}
                            </Link>
                            <span className="separator">/</span>
                          </li>
                        )}
                      </>
                    }
                  </p>
                ))}
              </>
            )}
            {(location.pathname == "/" || location.pathname == "/home") &&
              props.noService && (
                <>
                  <p>
                    {
                      <li className={"breadcrumb-item "}>
                        <Link to={"/"}>Home</Link>
                      </li>
                    }
                  </p>
                  {location.pathname !== "/" && (
                    <>
                      {linkHistory.map((x, index) => (
                        <p key={index}>
                          {
                            <li className={"breadcrumb-item "}>
                              <Link to={"/" + x}>
                                {capitalizeFirstLetter(x.replace("_", " "))}
                              </Link>
                            </li>
                          }
                        </p>
                      ))}
                    </>
                  )}
                </>
              )}
          </ol>
        </nav>
      </div>
    </>
  );
};

export default Breadcrumb;
